import * as React from "react"

export default function TicketSolidIcon(props) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21 3a1 1 0 011 1v5.5a2.5 2.5 0 000 5V20a1 1 0 01-1 1H3a1 1 0 01-1-1v-5.5a2.5 2.5 0 000-5V4a1 1 0 011-1h18z"
        fill={props.fill}
      />
    </svg>
  )
}
